import $ from 'jquery'

/**
 * @revision [EC] 16-02-'22 : tolto il bottone "X" per chiudere la cookiebar
 */
$.fn.cookieBar = function(options) {
  const settings = $.extend({
    'acceptButton': '.js-cookieBarAccept',
    'refuseButton'   : '#cookiesRefuse',
    //'refuseButtonEx' : '#cookiesRefuseEx',
    'secure': false,
    'path': '/',
    'domain': '',
    'threshold': 0 //[EC] 14-02-'22 : Imposto a 0 per non far accettare con scroll
  }, options)

  const _hide = ($cookiebar) => {
    $cookiebar
      .attr('aria-hidden', 'true')
      .attr('aria-live', 'off')
      .hide()
  }

  const _show = ($cookiebar) => {
    $cookiebar
      .attr('aria-hidden', 'false')
      .attr('aria-live', 'polite')
      .show()
  }

  const _accept = function() {
    // [EC] 14-02-'22 : il cookie dell'accettazione riporta l'istat perché i cookie sono condivisi sul dominio halleyweb.com
    $.cookie( ((window && window.ente) ? 'cookiebar'+ window.ente : 'cookiebar'), 'hide', {
      path: settings.path,
      secure: settings.secure,
      domain: settings.domain,
      expires: 180 // [EC] 14-02-'22 : aumentata la durata da 1 mese a 6 mesi (180 giorni)
    })
    location.reload() // Ricarico la pagina per fargli scaricare gli script di Google Analytics
    //$(document).trigger('accept.cookiebar', [$cookiebar])
  }

  const _acceptTechnical = function($cookiebar) {
    $.cookie(((window && window.ente) ? 'cookiebar'+ window.ente : 'cookiebar'), 'technical', {
      path: settings.path,
      secure: settings.secure,
      domain: settings.domain,
      expires: 180 // [EC] 14-02-'22 : aumentata la durata da 1 mese a 6 mesi (180 giorni)
    })
    $(document).trigger('accept.cookiebar', [$cookiebar]) // Nasconde la cookie bar
  }

  $(document).on('accept.cookiebar', (e, $cookiebar) => {
    _hide($cookiebar)
  })

  $.cookieBar = $.cookieBar || {}

  $.cookieBar.isAccepted = function() {
    let cookieName = ((window && window.ente) ? 'cookiebar'+ window.ente : 'cookiebar')
    return $.cookie(cookieName) === 'hide' || $.cookie(cookieName) == 'technical'
  }

  return this.each(function() {
    var $cookiebar = $(this)

    if (!$.cookieBar.isAccepted()) {
      if (settings.threshold > 0) {
        $(window).on('scroll.cookiebar', (function() {
          if ($(window).scrollTop() > settings.threshold) {
            $(window).unbind('scroll.cookiebar')
            _accept($cookiebar)
          }
        }))
      }
      _show($cookiebar)
    }

    $cookiebar
      .find(settings.acceptButton)
      .click(function() {
        _accept($cookiebar)
        return false
      })

    $cookiebar
      .find(settings.refuseButton) // Listener Bottone "Rifiuta"
      .click(function() {
        _acceptTechnical($cookiebar)
        return false
      })
/*
    $cookiebar
      .find(settings.refuseButtonEx) // Listener Bottone "Rifiuta" (con la X)
      .click(function() {
        _acceptTechnical($cookiebar)
        return false
      })
*/      
  })

}



// WEBPACK FOOTER //
// ./src/components/cookiebar/cookiebar.js